import { object, string } from 'yup'

export const addProductSchema = object({
  name: string().required('فیلد نام محصول الزامی است.'),
  product: string().required('فیلد نوع محصول الزامی است.'),
})
